import { isFunction } from "src/utils";
import promiseTimeout from "src/utils/promise-timeout";
import getDvid from "src/utils/get-dvid";
import { getCookie } from "src/utils/cookies";

/**
 * 内置逻辑，获取当前用户信息
 */
function getUserInfo() {
  let userid = getCookie('userid');
  let username = getCookie('username');

  return {
    uc: userid,
    userid,
    username,
  };
}

/**
 * 内置逻辑，获取业务领域、模块等数据
 */
// async function getDefaultBizData(): Promise<BizInfo> {
//   return {};
// }
const bizInfoKeys = [
  'env','dccode',
  'pdl','ytid','ytname',
  'domaincode','domainname',
  'labelcode','labelname',
  'appcode','appname',
  'servicecode','servicename','rolework',
  'billno', 'attrs',
  'appv', 'pkgname',
];
const CUSTOM_TIMEOUT = 1000;
let isFirst = true;
async function getBizContext(cfg: HBConfig): Promise<UserInfo & BizInfo> {
  // 业务数据
  const bizData: BizInfo = {};

  try {
    if(isFunction(cfg.getBizData)) {
      let timeout = CUSTOM_TIMEOUT;
      if (isFirst) {
        timeout = 5000;
        isFirst = false;
      }
      const cuBizData = await promiseTimeout(cfg.getBizData, timeout);
      bizInfoKeys.forEach(key => {
        if(cuBizData[key]) {
          bizData[key] = cuBizData[key];
        }
      });
    }
  } catch (error) {
    hbLogger.error('getBizData error. ', error);
  }
  if (!bizData.servicecode) {
    hbLogger.warn('必要字段属性servicecode缺失，将导致对应事件数据存储丢失');
  }
  // 用户信息
  let userInfo: UserInfo = { uc: '', userid: '', username: '' };

  try {
    if(isFunction(cfg.getUser)) {
      userInfo = await promiseTimeout<UserInfo>(cfg.getUser, CUSTOM_TIMEOUT);
    } else {
      userInfo = getUserInfo();
    }
  } catch (error) {
    hbLogger.error('getUser error. ', error);
  }
  if (!userInfo.userid) {
    const anonid = `anon_${getDvid()}`;
    userInfo = {
      uc: anonid,
      userid: anonid,
      username: '未知用户',
    };
  }

  const { attrs, ...otherBizData } = bizData || {};
  const curAttrs = Object.assign({}, cfg.attrs, attrs);
  try {
    const ymcFlag = decodeURIComponent(getCookie('ymc_flag') || '');
    if (/^bprId/.test(ymcFlag)) {
      const ymcFlagArr =  ymcFlag.split(';').map(item => item.split('='));
      const bprId = ymcFlagArr[0][1];
      curAttrs.bprId = bprId;
    }
  } catch (error) {
    hbLogger.warn('关联BPR录制报告ID执行异常。', error);
  }

  // 清除空值undefined null ''
  if (curAttrs) {
    Object.keys(curAttrs).forEach(key => {
      const value = curAttrs[key];
      if (value === undefined || value === null || value === '') {
        delete curAttrs[key];
      }
    });
  }
  return {
    uc: userInfo?.uc || userInfo?.userid,
    userid: userInfo?.userid,
    username: userInfo?.username,
    ...otherBizData,
    attrs: curAttrs,
  };
}

let cacheRet:Promise<UserInfo & BizInfo> = null;
export default async (cfg: HBConfig): Promise<UserInfo & BizInfo> => {
  if (!cacheRet) {
    cacheRet = getBizContext(cfg).finally(() => {
      setTimeout(() => {
        cacheRet = null;
      }, 200);
    });
  }
  return cacheRet;
}
